import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	root: {
		paddingTop: '8px',
	},
	section: {
		fontSize: '11px',
		fontWeight: 700,
		letterSpacing: '0.06em',
		textTransform: 'uppercase',
		color: 'text.secondary',
		padding: '14px 4px 6px',
	},
	link: {
		display: 'block',
		width: '100%',
		textAlign: 'left',
		borderRadius: '10px',
		color: 'inherit',
	},
	routeBadge: {
		fontSize: '12px',
		fontWeight: 700,
		color: 'var(--account-accent, #0C6DDF)',
		'.active &': {
			color: 'var(--account-accent-contrast, #fff)',
		},
	},
	empty: {
		fontSize: '13px',
		color: 'text.secondary',
		padding: '4px',
	},
} as const satisfies SxType
